import React from 'react'
import { get } from 'lodash'

import config from 'config'
import { Assessor as AssessorPage } from 'containers/pages/register'
import * as Assessor from 'containers/forms/assessor'
import { Redirect } from 'react-router-dom'

const urlPrefix = `${config.publicPath}/register/assessor`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <AssessorPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/assessor/welcome`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/welcome`,
        exact: true,
        component: props => (
          <Assessor.Experience {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/activity`,
        exact: true,
        component: props => (
          <Assessor.Activity {...props} />
        ),
        activeId: 2,
        routes: []
      },
      {
        path: `${urlPrefix}/details`,
        exact: true,
        component: props => (
          <Assessor.AssessorDetails {...props} />
        ),
        activeId: 3,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/contact-details`,
        exact: true,
        component: props => (
          <Assessor.ContactDetails {...props} />
        ),
        activeId: 4,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/account`,
        exact: true,
        component: props => (
          <Assessor.Account {...props} />
        ),
        activeId: 5,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <Assessor.Success {...props} />
        ),
        activeId: 6,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
